import 'chart.js/auto';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode(); 
}


platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    // Check for SW updates
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').then(reg => {
        reg.onupdatefound = () => {
          const newWorker = reg.installing;
          newWorker!.onstatechange = () => {
            if (newWorker!.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // New version available, reload page automatically
                window.location.reload();
              } 
            }
          };
        };
      });
    }
  })
  .catch(err => console.error(err));  
